/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {Location} from '@angular/common';
import {AfterViewInit, ChangeDetectionStrategy, Component, OnInit, Optional} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {NbWindowRef} from '@nebular/theme';
import {AuthService} from 'compob2b-auth';
import {DamCatalogPlain, FileService, Role} from 'compob2b-libs';
import {map, tap} from 'rxjs/operators';
import {translations} from '../../../../environments/translations.ru';
import {CreateUpdateComponent} from '../../../admin-shared/crud-components/create-update/create-update.component';
import {CrudConfig} from '../../../admin-shared/interfaces/crud.config';
import {RelatedEntity} from '../../../admin-shared/interfaces/related.entity';
import {FormConfigService} from '../../../admin-shared/services/form-config.service';
import {DAM_ITEM_FORM} from '../dam-forms.config';
import {DamService} from '../dam.service';

@Component({
  selector: 'app-dam-create',
  templateUrl: './create-update-dam.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreateUpdateDamComponent extends CreateUpdateComponent<DamCatalogPlain> implements OnInit, AfterViewInit {

  title = translations.folders;
  protected uri = '/dam-menu/rapid';
  protected allRoles: Role[];
  absolutePath = '/cabinet/dam';
  config: CrudConfig = {
    uri: this.uri,
    columns: DAM_ITEM_FORM,
    title: this.title,
    absolutePath: this.absolutePath,
  };
  model: any;
  catalogTreeSynonym = false;

  constructor(
    protected readonly damService: DamService,
    protected readonly formConfigService: FormConfigService,
    protected readonly route: ActivatedRoute,
    protected readonly location: Location,
    @Optional() protected readonly windowRef: NbWindowRef,
    protected readonly fileService: FileService,
    protected readonly authService: AuthService
  ) {
    super(formConfigService, route, location, windowRef, fileService);
  }

  ngOnInit() {
    this.config.columns.forEach(item => {
      if (item.key === 'roles') {
        item.templateOptions.disabled = !this.authService.isSuperAdmin();
      }
    });

    this.id = this.route.snapshot.paramMap.get('id');
    this.damService.getLazyCatalogTree().pipe(
      map(catalogList => catalogList.filter(catalog => parseInt(this.id, 10) !== catalog.id))
    );

    const roles = this.compoApiService.get<Role[]>('/dam-menu/list-roles/')
      .pipe(map(response => response.data), tap(data => this.allRoles = data));

    this.config.relatedEntity = [
      {multipleEntity: roles, multipleField: 'roles'}
    ];

    super.setConfig(this.config);
    super.ngOnInit();
    this.initParentCatalog();
    this.model.editMode = this.editMode;

  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
    this.cdr.detectChanges();
  }

  /**
   * we need to initialize parentId property
   * even when we are creating a new record (creating mode)
   */
  private initParentCatalog(): void {
    const parent = this.route.snapshot.paramMap.get('parent');
    this.model = {id: null, header: null, parentId: null};

    if (!this.editMode) {
      this.model.parentId = 1;
    }

    if (parent !== null) {
      this.model.parentId = Number(parent);
    }
  }

  afterSetModel(): void {
    this.model.roles = this.model.roles.map((role: Role) => role.id);
    this.editName = this.model.header;
  }

  beforeSubmit(): void {
    this.entity = {...this.model};
    this.entity.termIDs = 'terms' in this.model && Array.isArray(this.model.terms) ? this.model.terms.map(term => term.id) : [];
    this.entity.catalogTreeSynonym = this.catalogTreeSynonym;
    this.entity.roles = this.model.roles === null ? [] : this.allRoles.filter(role => this.model.roles.includes(role.id));
  }

  changeCatalogTreeSynonym() {
    this.catalogTreeSynonym = !this.catalogTreeSynonym;
  }
}
